function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Rectangle from "terriajs-cesium/Source/Core/Rectangle";
import CameraView from "./CameraView";
import GlobeOrMap from "./GlobeOrMap";
class NoViewer extends GlobeOrMap {
  constructor(terriaViewer, _container) {
    super();
    _defineProperty(this, "type", NoViewer.type);
    _defineProperty(this, "terria", void 0);
    _defineProperty(this, "canShowSplitter", false);
    _defineProperty(this, "_currentView", new CameraView(Rectangle.MAX_VALUE));
    this.terria = terriaViewer.terria;
  }
  destroy() {}
  doZoomTo(v, _t) {
    if (v instanceof CameraView) {
      this._currentView = v;
    } else if (v instanceof Rectangle) {
      this._currentView = new CameraView(v);
    }
    return Promise.resolve();
  }
  setInitialView(view) {
    this._currentView = view;
  }
  notifyRepaintRequired() {}
  pickFromLocation(_latLngHeight, _providerCoords, _existingFeatures) {}
  getCurrentCameraView() {
    return this._currentView;
  }
  getContainer() {
    return undefined;
  }
  pauseMapInteraction() {}
  resumeMapInteraction() {}
  _addVectorTileHighlight(_imageryProvider, _rectangle) {
    return () => {};
  }
}
_defineProperty(NoViewer, "type", "none");
export default NoViewer;